import { useEffect, useState, useCallback } from "react";
import { useAuth } from "@/auth/AuthProvider";
import { Button } from "@/components/ui/button";

const STORAGE_KEY = "garnacha_welcome_shown_session";

export default function WelcomeModal() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (!user) return;
    const msg = (user.welcome_message || "").trim();
    if (!msg) return;
    // Show once per session — sessionStorage clears on tab close
    const flag = `${STORAGE_KEY}:${user.email}`;
    if (sessionStorage.getItem(flag)) return;
    sessionStorage.setItem(flag, "1");
    setOpen(true);
    // Slight delay before mount-in for the fade-in to feel intentional
    requestAnimationFrame(() => setMounted(true));
  }, [user]);

  const close = useCallback(() => {
    setMounted(false);
    setTimeout(() => setOpen(false), 300);
  }, []);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") close(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, close]);

  if (!open || !user) return null;

  const firstName = (user.name || user.email).split(" ")[0].split("@")[0];

  return (
    <div
      className={`fixed inset-0 z-[100] flex items-center justify-center px-6 py-8 transition-opacity duration-300 ${
        mounted ? "opacity-100" : "opacity-0"
      }`}
      role="dialog"
      aria-modal="true"
      data-testid="welcome-modal"
      onClick={(e) => { if (e.target === e.currentTarget) close(); }}
      style={{
        backgroundColor: "rgba(15, 14, 12, 0.78)",
        backdropFilter: "blur(14px)",
        WebkitBackdropFilter: "blur(14px)",
      }}
    >
      <div
        className={`max-w-3xl w-full text-center transition-all duration-500 ${
          mounted ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"
        }`}
      >
        <div className="flex flex-col items-center gap-8">
          <img
            src="/garnacha-logo.svg"
            alt="Garnacha"
            className="w-20 h-20 object-contain drop-shadow-[0_4px_30px_rgba(232,93,4,0.45)]"
            draggable={false}
          />

          <div className="text-[10px] tracking-[0.4em] uppercase font-bold text-[#E85D04]">
            Garnacha · Hola, {firstName}
          </div>

          <h1
            className="font-display font-bold text-white leading-[1.05] text-balance px-2"
            style={{
              fontSize: "clamp(2.2rem, 5.5vw, 4.4rem)",
              letterSpacing: "-0.02em",
              textShadow: "0 2px 40px rgba(0,0,0,0.5)",
            }}
            data-testid="welcome-message"
          >
            {user.welcome_message}
          </h1>

          <Button
            onClick={close}
            data-testid="welcome-enter-btn"
            className="bg-[#E85D04] hover:bg-[#c94b03] text-white font-display font-semibold tracking-wider uppercase text-sm h-12 px-12 rounded-full mt-2 shadow-[0_8px_30px_rgba(232,93,4,0.45)] transition-transform hover:scale-[1.02]"
          >
            Entrar
          </Button>

          <div className="text-[10px] tracking-[0.32em] uppercase font-semibold text-white/60 mt-4">
            DRIP IT. DIP IT. <span className="text-[#E85D04]">LOVE IT.™</span>
          </div>
        </div>
      </div>
    </div>
  );
}
